/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Created_ToastInputs */

const cs_franchise_created_toast = /** @type {(inputs: Franchise_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licence vytvořena`)
};

const en_franchise_created_toast = /** @type {(inputs: Franchise_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License created`)
};

/**
* | output |
* | --- |
* | "License created" |
*
* @param {Franchise_Created_ToastInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_created_toast = /** @type {((inputs?: Franchise_Created_ToastInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Created_ToastInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_created_toast(inputs)
	return cs_franchise_created_toast(inputs)
});